import React from "react";
import { useTranslation } from "react-i18next";
import { ContentsBasic } from "../../organisms/contentsBasic";
import IntroText from "../../organisms/introText/index";
import Footer from "../../organisms/footerBasic/index";
import "./style.scss";
import Alert from "../../common/alert";
import ConfirmPopup from "../../common/confirm";
import YesConfirmPopup from "../../common/yesConfirm";
import LanguageSwitcher from "../../common/languageSwitcher";

const IntroLayout = ({ children, config }) => {
  const { t } = useTranslation();
  const welcomeLines = t("intro.welcome.title").split("\n");
  return (
    <>
      <div
        id="layout"
        className="layout-intro"
        style={{
          backgroundImage: "url(./assets/images/intro/layout_intro_bg1.jpg)",
        }}
      >
        <div style={{ position: "absolute", top: 16, right: 24, zIndex: 2 }}>
          <LanguageSwitcher />
        </div>
        <ContentsBasic>
          <IntroText
            title={
              <span>
                {welcomeLines.map((line, index) => (
                  <React.Fragment key={index}>
                    {line}
                    {index < welcomeLines.length - 1 && <br />}
                  </React.Fragment>
                ))}
              </span>
            }
            description={<span>{t("intro.welcome.description")}</span>}
            buttonHref={config.introLearnMoreUrl}
          ></IntroText>
          {children}
        </ContentsBasic>
        <Footer></Footer>
      </div>
      <Alert />
      <ConfirmPopup />
      <YesConfirmPopup />
    </>
  );
};

export default IntroLayout;
